import _objectSpread from"/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";/**
 * Play (filled): a solid right-pointing triangle — the primary playback
 * control, where the dominant action should carry more weight than the
 * outline affordances around it.
 *
 * Progress swells it and settles it back. See playBase for the geometry and
 * the pulse.
 *
 * Color slot: 0 the triangle.
 */import*as React from"react";import{pulsedTriangle}from"web/shared/icons/glyphs/playBase";import{fillPalette}from"web/shared/icons/colorVector";import{jsx as _jsx}from"react/jsx-runtime";function PlayFilledGlyph(props){// The fill rides the wrapping group, which is the contract every -filled
// glyph follows.
return/*#__PURE__*/_jsx("g",_objectSpread(_objectSpread({},fillPalette(props.colors)[0]),{},{children:/*#__PURE__*/_jsx("path",{d:pulsedTriangle(props.progress)})}));}export default PlayFilledGlyph;